import React from 'react';

export default ({ list, onItemSelect, onResetList }) => {
  return (
    <div>
      {list.map((item, i) =>
        <button key={i} 
                className={`billy-select-cursor__button billy-button ${item.active ? 'billy_active' : ''}`}
                aria-label={item.active ? 'אפס סמן' : `שנה סמן ל${ item.label }`}
                onClick={() => item.active ? onResetList() : onItemSelect(item.id)}>
                <img className="billy-select-cursor__image" src={item.src} aria-hidden="true" />
        </button>
      )}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/SelectList/CursorsList/index.js